<template>
  <div>

    <el-row  class="padded" justify="center">
      <el-col :span="24">
        <h3><i class="fa fa-cog">&nbsp;</i><org-badge />&nbsp;Settings</h3>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="2">

        <el-menu v-model="menu" :collapse="true" @select="show" background-color="#F2F6FC">

          <el-menu-item-group title="Organisations">
            <template slot="title">
              <el-tooltip content="Organisations" effect="light" placement="right">
                <i class="fa fa-th-large text-muted"></i>
              </el-tooltip>
            </template>

            <el-menu-item index="orgs-xolas" v-if="isManager()">
              <i class="fa fa-star">&nbsp;</i>
              <span slot="title">{{ellipsis(clientName, 15)}}</span>
            </el-menu-item>

            <el-menu-item index="orgs-telco" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-users">&nbsp;</i>
              <span slot="title">Telcos</span>
            </el-menu-item>

            <el-menu-item index="orgs-contractor" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-tools">&nbsp;</i>
              <span slot="title">Contractors</span>
            </el-menu-item>

            <el-menu-item index="orgs-backhaul" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-wifi">&nbsp;</i>
              <span slot="title">Backhaul Providers</span>
            </el-menu-item>

            <el-menu-item index="orgs-landlord" v-if="canAccess('property|finance|management')">
              <i class="fa fa-home">&nbsp;</i>
              <span slot="title">Landlords</span>
            </el-menu-item>

            <el-menu-item index="orgs-insurer" v-if="canAccess('admin|property|finance|management')">
              <i class="fa fa-shield-alt">&nbsp;</i>
              <span slot="title">Insurers</span>
            </el-menu-item>

            <el-menu-item index="orgs-utility" v-if="canAccess('admin|property|finance|management')">
              <i class="fa fa-plug">&nbsp;</i>
              <span slot="title">Utilities</span>
            </el-menu-item>

            <el-menu-item index="orgs-authority" v-if="canAccess('admin|property|finance|management')">
              <i class="fa fa-university">&nbsp;</i>
              <span slot="title">Authorities</span>
            </el-menu-item>


            <el-menu-item index="orgs-tower-supplier" v-if="canAccess('project|maintenance|finance|management')">
              <i class="fa fa-tower-cell">&nbsp;</i>
              <span slot="title">Tower Suppliers</span>
            </el-menu-item>

          </el-menu-item-group>


          <el-menu-item-group v-if="isManager()">
            <template slot="title">
              <el-tooltip content="System" effect="light" placement="right">
                <i class="fa fa-tasks text-muted"></i>
              </el-tooltip>
            </template>

            <el-menu-item index="workflow" v-if="isManager('project|maintenance|admin')">
              <i class="fa fa-cogs">&nbsp;</i>
              <span slot="title">Master Workflows</span>
            </el-menu-item>

            <el-menu-item index="cats" v-if="isSuper()">
              <i class="fa fa-tags">&nbsp;</i>
              <span slot="title">Categories</span>
            </el-menu-item>

            <el-menu-item index="loc">
              <i class="fa fa-map-pin">&nbsp;</i>
              <span slot="title">Localities</span>
            </el-menu-item>

            <el-menu-item index="struct">
              <i class="fa fa-broadcast-tower">&nbsp;</i>
              <span slot="title">Structures</span>
            </el-menu-item>
<!--
            <el-menu-item index="users">
              <i class="fa fa-user">&nbsp;</i>
              <span slot="title">Users</span>
            </el-menu-item>
-->
          </el-menu-item-group>

          <el-menu-item-group v-if="isManager()">
            <template slot="title">
              <el-tooltip content="Other Settings" effect="light" placement="right">
              <i class="fa fa-random text-muted">&nbsp;</i>
            </el-tooltip>
            </template>

            <el-menu-item index="finance" v-if="isManager('finance|management|admin')">
              <i class="fa fa-dollar-sign">&nbsp;</i>
              <span slot="title">Finance</span>
            </el-menu-item>

            <el-menu-item index="backup" v-if="isManager()">
              <i class="fa fa-save">&nbsp;</i>
              <span slot="title">Backup Data</span>
            </el-menu-item>

            <el-menu-item index="logs" v-if="isManager()">
              <i class="fa fa-user">&nbsp;</i>
              <span slot="title">System Users</span>
            </el-menu-item>

          </el-menu-item-group>
        </el-menu>
      </el-col>

      <el-col :span="21">

        <div>
          <component v-bind="defaultProps" :is="comp" />
        </div>

      </el-col>
    </el-row>
  </div>

</template>

<script>

import FormattingMixins from '@/mixins/FormattingMixins'

import ComingSoon from '@/components/settings/ComingSoon'

import AuditLogs from '@/components/settings/AuditLogs'

import Backup from '@/components/settings/Backup'
import Categories from '@/components/settings/Categories'

import FinanceSettings from '@/components/settings/FinanceSettings'
import Locality from '@/components/settings/Locality'

import StructTable from '@/components/tables/StructTable'
import OrgTable from '@/components/tables/OrgTable'

import Workflow from '@/components/workflow/Workflow'

export default {
  mixins: [FormattingMixins],

  methods: {
    show (menu, index, item) {

      this.comp = ComingSoon

      delete this.defaultProps.category
      delete this.defaultProps.title
      delete this.defaultProps.showSearch

      if (menu.startsWith('orgs')) {
        this.defaultProps.category = menu.replace('orgs-', '').replace('-', ' ')

        this.defaultProps.title = this.pluralise(this.titleCase(this.defaultProps.category === 'backhaul' ? 'Backhaul Providers' : this.defaultProps.category))

        this.defaultProps.showSearch = (menu.startsWith('orgs-xolas') ? false : true)
        this.defaultProps.showRefresh = (menu.startsWith('orgs-xolas') ? false : true)

        if (menu.startsWith('orgs-xolas')) {
          this.defaultProps.title = this.xolasClient().name
        }

//        console.log('Settings: ', this.defaultProps)
        this.comp = OrgTable
      }

      if (menu === 'cats') {
        this.comp = Categories
      }

      if (menu === 'finance') {
        this.comp = FinanceSettings
      }

      if (menu === 'loc') {
        this.comp = Locality
      }

      if (menu === 'struct') {
        this.comp = StructTable
      }

      if (menu === 'workflow') {
        this.comp = Workflow
      }

      if (menu === 'backup') {
        this.comp = Backup
      }

      if (menu === 'logs') {
        this.comp = AuditLogs
      }

    }
  },

  data () {
    return {
      menu: 'orgs-licensee',
      comp: OrgTable,
      telcoId: this.isTelco() ? this.org().id : null,
      defaultProps: {},
      clientName: this.xolasClient().name,
      clientLogo: this.xolasClient().logoPath
    }

  }
}

</script>

<style scoped>
.menu-header { color: darkorange; }
</style>



// WEBPACK FOOTER //
// SettingsView.vue?bf88d57a